const playVideo =(element) => {
    element.querySelector('video').play();
    if(element.querySelector(".poster-trigger")) element.querySelector(".poster-trigger").classList.add('hidden')
    if(element.querySelector(".deferred-media__poster-button")) element.querySelector(".deferred-media__poster-button").classList.add('hidden')
}

const stopVideo = (element) => {
    element.querySelector('video').pause();
    if (element.querySelector(".deferred-media__poster-button")) element.querySelector(".deferred-media__poster-button").classList.remove('hidden')
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("carousel-component .video-slide-wrapper").forEach((button) => {
        button.addEventListener("mouseover", () => playVideo(button));
        button.addEventListener("mouseleave", () => stopVideo(button));


        button.addEventListener("touchstart", () => playVideo(button));
        button.addEventListener("touchend", () => stopVideo(button));
    })
})